<template>
  <detail-layer
    :show-btn="showBtn"
    @pass="handleCheck(1)"
    @refuse="handleCheck(2)"
  >
    <div id="potree_sidebar_container"></div>
    <div class="pcr-task-detail" ref="container"></div>
    <div class="material-attr-btn-group">
      <el-button type="primary" @click="changeMaterialAttr('intensity')">强度</el-button>
      <el-button type="primary" @click="changeMaterialAttr('rgba')">rgba</el-button>
    </div>
  </detail-layer>
</template>

<script>
// import {loadPotree} from "@/utils/load-potree";
import { getPcrTaskDetail, checkPcrTask } from '@/api/pcr'
import DetailLayer from "@/views/pcr/components/detail-layer";
import { ACESFilmicToneMapping } from 'three'

export default {
  name: 'PcrTaskDetail',
  components: { DetailLayer },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
  data() {
    return {
      path: '',
      showBtn: false
    }
  },
  methods: {
    createProtree() {
      if (!this.$refs.container || !this.Potree || !this.path) { return }
      window.viewer = new this.Potree.Viewer(this.$refs.container);
      viewer.setEDLEnabled(false);
      viewer.setFOV(60);
      viewer.setPointBudget(100000000);
      viewer.loadSettingsFromURL();
      viewer.setBackground("gradient");
      viewer.setMinNodeSize(50)
      
      viewer.renderer.toneMapping = ACESFilmicToneMapping
      viewer.renderer.toneMappingExposure = 1
      viewer.useHQ = true

      viewer.loadGUI(() => {
        viewer.setLanguage('en');
        $("#menu_scene").next().show();
        $("#menu_tools").next().show();
        viewer.toggleSidebar();
      });
      this.Potree.loadPointCloud(`${this.path}cloud.js`, "", ({pointcloud}) => {
        const material = pointcloud.material;
        material.pointSizeType = this.Potree.PointSizeType.FIXED;
        material.size = 0.7
        material.elevationRange = [0, 70]
        material.weightRGB = 1.0
        material.weightElevation = 1.0;
        // console.log(material.activeAttributeName)
        // material.activeAttributeName = "intensity";
        viewer.scene.addPointCloud(pointcloud);
        viewer.fitToScreen();
      });
    },
    async initProtree() {
      this.Potree = window.Potree;
      this.createProtree()
    },
    async initData() {
      const res = await getPcrTaskDetail(this.id)
      this.path = res.potree_path;
      this.showBtn = res.check_status === 0
      this.createProtree()
    },
    // 审核
    async handleCheck(checkStatus) {
      try {
        await checkPcrTask({
          pcr_task_id: this.id,
          check_to: checkStatus
        })
        this.$message({ message: '审核成功' })
        this.$router.back();
      } catch (e) {
        console.log(e);
      }
    },
    changeMaterialAttr(attr) { 
      if (viewer &&  viewer.scene && viewer.scene.pointclouds[0]) {
        viewer.scene.pointclouds[0].material.activeAttributeName = attr
      }
    }
  },
  created() {
    this.initProtree()
    this.initData()
  },
  mounted() {
    this.createProtree()
  }
}
</script>

<style scoped lang="scss">
.pcr-task-detail {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

#potree_sidebar_container {
  z-index: 1;
}

.material-attr-btn-group {
  position: absolute;
  top: 0;
  left: 301px;
}
</style>
